import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=ef519db6&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=ts"
export * from "./CreateCard.vue?vue&type=script&lang=ts"
import style0 from "./CreateCard.vue?vue&type=style&index=0&id=ef519db6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef519db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef519db6')) {
      api.createRecord('ef519db6', component.options)
    } else {
      api.reload('ef519db6', component.options)
    }
    module.hot.accept("./CreateCard.vue?vue&type=template&id=ef519db6&scoped=true", function () {
      api.rerender('ef519db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/CreateCard.vue"
export default component.exports